/**
 * Formik values for multi-select may be a string (legacy single-select) or
 * `string[]`. Coerces to `string[]` so we never spread a string into characters.
 */
export function toMultiSelectStringArray(raw: unknown): string[] {
  if (Array.isArray(raw)) {
    return raw.filter((v): v is string => typeof v === "string");
  }
  if (raw == null || raw === "") {
    return [];
  }
  if (typeof raw === "string") {
    return [raw];
  }
  return [];
}
